<template>
  <div class="demandpage">
    <TheDemandHeader title="利用人数を選択してください" page="2" />

    <TheDemandSelectSeatCountAndPickupTime
      v-model:seatCount="seatCount"
      v-model:pickuptime="pickuptime"
      v-model:isValidSeatCount="isValidSeatCount"
    />

    <TheDemandActionButton2
      :seat-count="seatCount"
      :pickuptime="pickuptime"
      :is-valid-seat-count="isValidSeatCount"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import nativeHandlerService from "@/services/nativeHandler";

import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "TemplateDemandBooking2",
  setup() {
    const store = useStore();
    const router = useRouter();

    // 価格区分ごとに何枚選択されたかを保持。仮予約APIに乗っける形式を踏襲
    const seatCount = ref({});

    // 今すぐのみの仕様なので文字列current
    const pickuptime = ref("current");

    // 次ページへの遷移ボタンのdisabled判定フラグ コントロールは子コンポーネント
    const isValidSeatCount = ref(true);

    return {
      seatCount,
      pickuptime,
      isValidSeatCount,
    };
  },
};
</script>
